$shm_hitalama_map_widget_float_code_html_bench_result $shm_hitalama_map_widget_float_code_bench_result
	result_view /
		<= Frame $mol_frame
			html <= state
